import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal } from "@mui/material";

const CustomModal = ({
  open,
  onCloseHandler,
  children,
  modalWidth = 400,
  title = "",
}) => {
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          bgcolor: "background.paper",
          boxShadow:
            "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
          overflowY: "auto",
          // Mobile: full screen
          top: { xs: 0, sm: "50%" },
          left: { xs: 0, sm: "50%" },
          transform: { xs: "none", sm: "translate(-50%, -50%)" },
          width: { xs: "100%", sm: modalWidth },
          maxWidth: { xs: "100%", sm: `${modalWidth}px` },
          height: { xs: "100%", sm: "auto" },
          maxHeight: { xs: "100%", sm: "90vh" },
          borderRadius: { xs: 0, sm: "12px" },
          p: { xs: 2, sm: 3 },
          pt: { xs: 2, sm: 3 },
        }}
      >
        <Box
          component="h2"
          sx={{ fontWeight: 700, fontSize: { xs: "22px", sm: "28px" }, lineHeight: "1.4" }}
          mt={0}
          mb={3}
          id="parent-modal-title"
        >
          {title}
        </Box>
        <IconButton
          sx={{ position: "absolute", right: "15px", top: "10px", width: "auto" }}
          aria-label="close"
          onClick={onCloseHandler}
        >
          <CloseIcon />
        </IconButton>
        {children}
      </Box>
    </Modal>
  );
};

export default CustomModal;
